function resolvePlaceholderColor(defaultColor = '#999') {
  if (typeof window === 'undefined') return defaultColor;
  const val = getComputedStyle(document.documentElement)
    .getPropertyValue('--input-placeholder-color')
    .trim();
  return val || defaultColor;
}

function getDefaultSelectStyleTokens(placeholderColor) {
  const isDarkTheme = document.documentElement.classList.contains('picsioThemeDark') ||
    !document.documentElement.classList.contains('picsioThemeLight');

  return {
    controlBg: '#303030',
    controlColor: '#999',
    valuePadding: '0 8px',
    placeholderColor,
    optionPadding: '10px 15px 10px 20px',
    optionFocusedColor: 'var(--primary-contrast-color)',
    optionSelectedColor: 'var(--secondary-contrast-color)',
    optionBg: 'var(--background-main-color)',
    optionFocusedBg: 'var(--primary-main-color)',
    optionSelectedBg: isDarkTheme ? '#161616' : '#e8e8e8',
    menuList: 'var(--background-main-color)',
  };
}

function buildSelectStyles(tokens) {
  return {
    control: (base) => ({
      ...base,
      color: tokens.controlColor || base.color,
      backgroundColor: tokens.controlBg || base.backgroundColor,
    }),
    valueContainer: (base) => ({
      ...base,
      padding: tokens.valuePadding || base.padding,
    }),
    placeholder: (base) => ({
      ...base,
      color: tokens.placeholderColor || base.color,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 2,
      width: '150px',
    }),
    menuList: (base) => ({
      ...base,
      padding: '0',
      backgroundColor: tokens.menuList || base.backgroundColor,
    }),
    input: (base) => ({
      ...base,
      color: 'var(--secondary-contrast-color)',
      width: '30px',
    }),
    option: (base, state) => {
      const { isSelected, isFocused } = state;
      const style = { ...base, padding: tokens.optionPadding || base.padding };
      if (isSelected) {
        style.color = tokens.optionSelectedColor || base.color;
        style.backgroundColor = tokens.optionSelectedBg || base.backgroundColor;
      } else if (isFocused) {
        style.color = tokens.optionFocusedColor || base.color;
        style.backgroundColor = tokens.optionFocusedBg || base.backgroundColor;
      } else {
        style.color = base.color;
        style.backgroundColor = tokens.optionBg || base.backgroundColor;
      }
      style.fontSize = '14px';
      return style;
    },
  };
};

export { buildSelectStyles, resolvePlaceholderColor, getDefaultSelectStyleTokens };
